import styled from '@emotion/styled'
import { Text } from 'theme-ui'

import { WithTheme } from '../../../setup'
import media from '../../../common/MediaQueries'
import { IconTick } from '../../../assets/svg'
import { listReset } from '../../../common/Mixins'

export const WebtraderStyled = styled.div``

export const WebtraderMediaStyled = styled.div``

export const WebrtaderListStyled = styled.ul`
  ${listReset}
  display: flex;
  flex-direction: column;
  margin-top: 6.25rem;

  @media ${media.phone} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    max-width: 85.375rem;
    margin-left: auto;
    margin-right: auto;
  }
`

export const WebrtaderListItemStyled = styled.li`
  display: flex;
  &:not(:first-child) {
    margin-top: 1.5rem;
  }
  @media ${media.phone} {
    max-width: 17.125rem;
    &:not(:first-child) {
      margin-top: 0;
      margin-left: 2rem;
    }
  }
`

export const WebtraderIconWrapper = styled(IconTick)`
  margin: 0.5rem 1.25rem 0 0;
  min-width: 1rem;
`

export const WebtraderLabelStyled = styled(Text)<WithTheme>`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-family: 'Montserrat';
`

export const WebtraderActionStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4rem;
  @media ${media.phone} {
    margin-top: 6rem;
  }
`
